export const state = () => ({
  favorites: [],
  isOpen: false,
})

export const mutations = {
  setFavorites(state, favorites) {
    state.favorites = favorites
  },
  setOpen(state) {
    state.isOpen = true

    document.body.classList.add('max-md:overflow-hidden')
  },
  setClose(state) {
    state.isOpen = false

    document.body.classList.remove('max-md:overflow-hidden')
  },
}

export const actions = {
  async getFavorites({ commit }) {
    const { data: favorites } = await this.$axios.$get('/shop/favorites', {
      params: {
        guest_id: this.$auth.$storage.getUniversal('guest_id'),
      },
    })

    this.$auth.$storage.setUniversal('guest_id', favorites.guest_id)

    commit('setFavorites', favorites)
  },

  async linkGuestFavorites({ commit }) {
    const { data: favorites } = await this.$axios.$post(
      '/shop/favorites/link-guest-favorites',
      {
        guest_id: this.$auth.$storage.getUniversal('guest_id'),
      }
    )

    this.$auth.$storage.setUniversal('guest_id', favorites.guest_id)

    commit('setFavorites', favorites)
  },

  async addToFavorites({ commit }, entryId) {
    const { data: favorites } = await this.$axios.$post(
      '/shop/favorites/item/add',
      {
        entry_id: entryId,
        guest_id: this.$auth.$storage.getUniversal('guest_id'),
      }
    )

    commit('setFavorites', favorites)
  },

  async removeFromFavorites({ commit }, entryId) {
    const { data: favorites } = await this.$axios.$post(
      '/shop/favorites/item/remove',
      {
        entry_id: entryId,
        guest_id: this.$auth.$storage.getUniversal('guest_id'),
      }
    )

    commit('setFavorites', favorites)
  },
}

export const getters = {
  favorites: (state) => state.favorites,
  isOpen: (state) => state.isOpen,
}
